<template>
  <nav class="bg-white dark:bg-gray-900 sticky w-full top-0 left-0 border-b border-gray-200 dark:border-gray-600 z-40">
    <div class="max-w-screen-xl flex items-center justify-between mx-auto sm:p-1 p-4">
      <a href="/" class="flex items-center">
        <img src="@/assets/logo.png" class="max-h-16 sm:mr-3 pr-2 sm:pr-8" alt="Present Planner Logo" />
      </a>

      <div class="flex items-center md:order-2 sm:px-2 md:px-4 gap-1 md:gap-4">
        <a href="/blog" class="hidden md:flex text-gray-700 hover:text-red-600 font-medium mr-2">Blog</a>
        <button
v-if="isLoggedIn" @click="signOut" type="button"
          class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg md:text-sm sm:text-xs px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-red-600 dark:focus:ring-red-800"
>
          Logout
        </button>
        <a v-if="!isLoggedIn" href="/register">
          <button
type="button"
            class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg md:text-sm text-xs px-4 py-2 text-center whitespace-nowrap min-w-[100px] dark:bg-red-600 dark:hover:bg-red-600 dark:focus:ring-red-800"
>
            Get started
          </button>
        </a>
        <a v-if="!isLoggedIn" href="/login">
          <button
type="button"
            class="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg md:text-sm text-xs px-4 py-2 text-center dark:bg-green-600 dark:hover:bg-green-600 dark:focus:ring-green-800"
>
            Login
          </button>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { Auth } from "aws-amplify";

import { mapGetters } from "vuex";

export default {
  name: "Header",
  components: {},
  props: {
    title: {
      type: String,
      default: "Present Planner",
    },
    page: {
      type: String,
      default: "Dashboard",
    },
  },
  data() {
    return {
      deferredPrompt: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    environment() {
      return process.env.VUE_APP_ENVIRONMENT;
    },
    isLoggedIn() {
      return this.$store.state.user.loggedIn;
    },
    userDisplayName() {
      if (this.$store.state.user.loggedIn) {
        try {
          return this.$store.state.user.data.email;
        } catch {
          return "there";
        }
      } else {
        return "there";
      }
    },
    isFederatedUser() {
      if (this.$store.state.user.loggedIn && this.$store.state.user.data) {
        return this.checkFederatedUser(this.$store.state.user.data);
      }
      return false;
    }
  },
  mounted() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },
  methods: {
    async signOut() {
      try {
        // For federated users, sign out globally to clear both Cognito and provider sessions
        if (this.isFederatedUser) {
          await Auth.signOut({ global: true });
        } else {
          // For regular email/password users, normal signout is sufficient
          await Auth.signOut();
        }

        // Clear local state
        this.$store.dispatch("fetchUser");
        this.$store.dispatch("resetState");

        // Redirect to home
        this.$router.push("/");

      } catch (error) {
        console.error('Error signing out:', error);
        // Even if signout fails, clear local state and redirect
        this.$store.dispatch("fetchUser");
        this.$store.dispatch("resetState");
        this.$router.push("/");
      }
    },
    async dismiss() {
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    checkFederatedUser(user) {
      // Check if user signed in via OAuth (Google, etc.)
      // Federated users will have identities array with provider info

      if (user && user.attributes) {
        // Method 1: Check identities attribute
        if (user.attributes.identities) {
          try {
            // Parse the JSON string or handle if it's already an array
            let identities;
            if (typeof user.attributes.identities === 'string') {
              identities = JSON.parse(user.attributes.identities);
            } else {
              identities = user.attributes.identities;
            }

            const isFederated = identities.some(identity =>
              identity.providerType === 'Google' ||
              identity.providerType === 'Facebook' ||
              identity.providerType === 'SAML' ||
              identity.provider === 'Google' ||
              (identity.provider && identity.provider !== 'Cognito')
            );

            if (isFederated) return true;
          } catch (error) {
            console.error('Error parsing identities:', error);
          }
        }

        // Method 2: Check if email_verified is false (common for OAuth users)
        // and other OAuth-specific attributes
        if (user.attributes['cognito:user_status'] === 'EXTERNAL_PROVIDER') {
          return true;
        }

        // Method 3: Check the username format - OAuth users often have provider prefixes
        if (user.username && (user.username.startsWith('Google_') || user.username.includes('google'))) {
          return true;
        }
      }

      // Method 4: Check the user object structure for OAuth-specific properties
      if (user && user.signInUserSession) {
        const accessToken = user.signInUserSession.accessToken;
        if (accessToken && accessToken.payload && accessToken.payload.token_use === 'access') {
          // Check if the user has OAuth-specific claims
          if (accessToken.payload.iss && accessToken.payload.iss.includes('cognito')) {
            // This is a Cognito token, check for OAuth indicators
            if (accessToken.payload['cognito:username'] &&
              accessToken.payload['cognito:username'].includes('Google')) {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
};
</script>
